import { z } from "zod";

export const ChecklistEntregaCadastroSchema = z.object({
    idChecklistEntrega: z.number().int().optional(),
    codigo: z.string().nonempty({ message: "O código é obrigatório." }),
    descricao: z.string().nonempty({ message: "A descrição é obrigatória." }),
    revisao: z.coerce.string().nullable().optional(),
    campo1: z.string().optional().nullable(),
    campo2: z.string().optional().nullable(),
    campo3: z.string().optional().nullable(),
    campo4: z.string().optional().nullable(),
    ativo: z.coerce.number().default(1),

});

export type ChecklistEntregaCadastroForm = z.infer<typeof ChecklistEntregaCadastroSchema>;

export const defaultChecklistEntregaCadastroForm: Partial<ChecklistEntregaCadastroForm> = {
    idChecklistEntrega: undefined,
    codigo: '',
    descricao: '',
    revisao: undefined,
    campo1: undefined,
    campo2: undefined,
    campo3: undefined,
    campo4: undefined,
    ativo: 1,

};
